import { useTheme } from '@simplywallst/ui-core';

const Dot = () => {
  const theme = useTheme();
  return <circle r="6" fill={theme.color.whiteRGBA(0.25)} />;
};

export const DotMarkers = () => {
  return (
    <svg width="100%" viewBox="0 0 240 240" fill="none">
      <g transform="translate(120, 16)">
        <Dot />
      </g>
      <g transform="translate(22, 88)">
        <Dot />
      </g>
      <g transform="translate(218, 88)">
        <Dot />
      </g>
      <g transform="translate(58, 205)">
        <Dot />
      </g>
      <g transform="translate(182, 205)">
        <Dot />
      </g>
    </svg>
  );
};
